import { action } from "typesafe-actions";
import ActionTypes from "../constants";

const landingR2D2Base = (ekind: string, edata, screen?: string) =>
  action(ActionTypes.TRACK, {
    ekind,
    okind: "tracker",
    edata: {
      screen: screen || "bike_index_screen",
      web_engage: true,
      ...edata
    },
    odata: {
      product: "bike",
      url: "/lp/new-bike"
    }
  });

export const landingPageLoaded = () =>
  landingR2D2Base("bike_landing_screen_loaded", {});

export const enterBikeRegNoClicked = () =>
  landingR2D2Base("bike_reg_no_entered_clicked", {});

export const dontKnowBikeNoClicked = () =>
  landingR2D2Base("bike_dont_know_reg_no_clicked", { reg_no: null });

export const brandNewBikeClicked = () =>
  landingR2D2Base("bike_brand_new_bike_clicked", {
    reg_no: null,
    journey: "new_bike"
  });

export const bikeRegNoEntered = bikeNo =>
  landingR2D2Base("bike_reg_no_entered", { reg_no: bikeNo });

export const invalidRegistrationNumber = bikeNo =>
  landingR2D2Base("invalid_reg_number", {
    invalid_registration_number: bikeNo,
  });

export const loaderScreenLoaded = reg_no =>
  landingR2D2Base(
    "loader_screen_loaded",
    {
      reg_no,
      screen: "bike_loader_screen"
    },
    "bike_loader_screen"
  );

export const searchBikeClicked = () =>
  landingR2D2Base("search_your_bike_clicked", {});

export const popularBikeSelected = variant =>
  landingR2D2Base("popular_bike_make_model_selected", {
    vehicle_make_model: variant
  });

export const normalBikeSelected = variant =>
  landingR2D2Base("make_model_selected", { vehicle_make_model: variant });

export const registrationYearSelected = age =>
  landingR2D2Base("bike_age_selected", { age });

export const policyExpirySelected = expiryStatus =>
  landingR2D2Base("bike_previous_policy_expiry_selected", {
    previous_policy_expiry: expiryStatus
  });

export const bikePreFilledLPClicked = () =>
  landingR2D2Base("bike_pre_filled_LP_clicked", {});

export const viewBilePriceCTAClick = formData =>
  landingR2D2Base("bike_view_price_cta_clicked", { ...formData });
